import { Component, inject } from '@angular/core';
import { CookieConsentService } from '../../providers/cookie-consent.service';

@Component({
  standalone: true,
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.css']
})
export class CookieConsentBannerComponent {
  protected readonly consent = inject(CookieConsentService);
}
